import { createAsyncThunk } from '@reduxjs/toolkit';
import { resetCreateCity } from '../slice';
import axiosInstance from 'utils/axios';

export const getAllCities = createAsyncThunk('cities/getAllCities', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/cities`);
    thunkAPI.dispatch(resetCreateCity());
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const getMasterCities = createAsyncThunk('cities/getMasterCities', async (provinceId, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/masters/cities?limit=40&province_id=${provinceId}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const getMasterProvinces = createAsyncThunk('cities/getMasterProvinces', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/masters/provinces`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const createCity = createAsyncThunk('cities/createCity', async (payload, thunkAPI) => {
  try {
    await axiosInstance.post(`/cities`, { name: payload.name });

    thunkAPI.dispatch(getAllCities());
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

export const deleteCity = createAsyncThunk('cities/deleteCity', async (id, thunkAPI) => {
  try {
    await axiosInstance.delete(`/cities/${id}`);

    thunkAPI.dispatch(getAllCities());
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});
